import { useId } from 'react';

/** The CertiHash mark: a hash sign whose centre cell is sealed, like a block in a chain. */
export function LogoMark({ size = 28, title }: { size?: number; title?: string }) {
  const id = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#14c79a" />
          <stop offset="1" stopColor="#067a60" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="9" fill={`url(#${id})`} />
      <path d="M12.4 13h8l-.8 6h-8z" fill="#fff" fillOpacity=".38" />
      <path
        d="M13 8.5 11 23.5M21 8.5 19 23.5M8.5 13h15M8 19h15"
        stroke="#fff"
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="ui-logo">
      <LogoMark size={size} />
      <span className="ui-logo__word">
        Certi<span>Hash</span>
      </span>
    </span>
  );
}
